<template>
  <v-row class="px-4 py-3">
    <v-dialog
      v-model="dialog"
      scrollable
      max-width="300px"
      fullscreen
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          :color="$bgColor"
          v-on="on"
          dark
          block
        >
          ประวัติการจอง
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </template>
      <v-card style="width:100px">
        <v-card-title>
          <strong>ประวัติการจอง</strong>
          <v-spacer></v-spacer>
          <p
            class="pr-0 pl-7 mb-0"
            style="color:red"
            @click="dialog = false"
          >
            ปิด
        </p>
        </v-card-title>
        <v-card-text class="pa-0" style="height: 300px;">
          <!-- <v-timeline
            dense
            style="width:269px"
              > -->
            <v-row v-if="allBookings" class="ms-2 me-2 mt-1" v-for="(booking, index) in allBookings" :key="index">
                <template>
                  <v-card
                    class="ma-2"
                    width="100%"
                    :style="'borderRadius: 7px;' + `borderLeft: solid 3px ${booking.color}`"
                    @click="gggg(index)"
                  >
                    <v-card-actions>
                      <v-btn
                        :color="booking.color"
                        text
                      >
                      <v-icon left>mdi-checkbox-blank-circle mdi-18px</v-icon>
                        {{ booking.status }}
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn
                        icon
                      >
                        <v-icon>{{ showDetailIndex === index ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                      </v-btn>
                    </v-card-actions>
                    <div class="ps-5 pb-1">
                        <h5 >{{ booking.title }}</h5>
                        <span style="color:#BDBDBD;">{{ booking.day }} | {{ booking.time }}</span>
                    </div>
                    <v-expand-transition>
                      <div v-show="showDetailIndex === index">
                        <v-card-text class="ps-5 pe-5 pb-4" style="font-size: 16px">
                          <span style="color:#BDBDBD;">สาขา:&nbsp;&nbsp;{{ booking.branch }}</span><br>
                          <span style="color:#BDBDBD;">ชื่อ:&nbsp;&nbsp;{{ booking.name }}</span><br>
                          <span style="color:#BDBDBD;">เบอร์:&nbsp;&nbsp; {{ booking.phone }}</span><br>
                          <span v-if="booking.note != null && booking.note !== ''" style="color:#BDBDBD;">หมายเหตุ:&nbsp;&nbsp;{{ booking.note }}<br></span><br>
                          <div class="text-center">
                            <v-btn block v-if="booking.link" :href="booking.link" target="_blank">
                              <v-icon color="indigo" class="pe-2">mdi-cash mdi-36px</v-icon>
                              หลักฐานยืนยันการจ่าย
                            </v-btn>
                            <v-btn block disabled v-else>
                              <v-icon color="indigo" class="pe-2">mdi-cash mdi-36px</v-icon>
                              หลักฐานยืนยันการจ่าย
                            </v-btn>
                          </div>
                          <v-btn block v-if="booking.linkMeet != null && booking.linkMeet !== ''" :href="booking.linkMeet" target="_blank" class="mt-3">
                            <v-icon color="indigo" class="pe-2">mdi-video-outline mdi-36px</v-icon>
                            {{ shopId ==='Ub7cbc419244731cdd682354dd0e57cef' ? 'เข้าสู่ห้องเรียน' : 'link meet' }}
                          </v-btn>
                        </v-card-text>
                      </div>
                    </v-expand-transition>
                  </v-card>
                </template>
            </v-row>
          <!-- </v-timeline> -->
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
// import { mapGetters } from 'vuex'
export default {
  props: ['allBookings'],
  data () {
    return {
      dialogm1: '',
      showDetailIndex: null,
      dialog: false,
      dialog1: false
    }
  },
  async mounted () {
    this.shopId = this.GET_SHOPID()
  },
  methods: {
    gggg (index) {
      // this.showDetailIndex = index
      if (this.showDetailIndex !== index) {
        this.showDetailIndex = index
      } else {
        this.showDetailIndex = null
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Card/C/EnglishMunMun.vue